<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <el-row>
                    <el-col>
                        <mass-expense-deal-edit-popup
                            :is-visible="isExpenseVisible"
                            :expense-id="expenseId"
                            :deal-id="dealId"
                            @changeVisibility="changeVisibility"
                            @getDataFromServer="getDataFromServer"
                        />
                    </el-col>
                    <el-col>
                        <div class="spreadsheet-header-title">
                            {{ title }}
                        </div>
                        <div class="spreadsheet-header-filter-info">
                            <span class="spreadsheet-header-filter-info_black">
                                Поиск по:
                            </span>
                            <span class="spreadsheet-header-filter-info_gray">
                                {{ filterTitle }}
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spreadsheet-header-filter-info_black">
                            Всего найдено:
                        </span>
                        <span class="spreadsheet-header-filter-info_gray">
                            {{ pagesInfo.total }} расходов на сумму {{ pagesInfo.totalAmount }} р.
                        </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.id" :label-width="formLabelWidth" v-if="isColumnVisible('id')">
                            <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.created_at" :label-width="formLabelWidth" v-if="isColumnVisible('created_at')">
                            <el-date-picker
                                v-model="filterModel.created_at"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.creator_full_name" :label-width="formLabelWidth" v-if="isColumnVisible('created_by.full_name')">
                            <el-select
                                v-model="filterModel.creator_full_name"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.creator_full_name"
                                size="mini"
                            >
                                <el-option v-for="item in employersList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.deal_id" :label-width="formLabelWidth" v-if="isColumnVisible('deal_id')">
                            <el-input v-model="filterModel.deal_id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.deal_contract" :label-width="formLabelWidth" v-if="isColumnVisible('deal.contract_number')">
                            <el-input v-model="filterModel.deal_contract" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.address" :label-width="formLabelWidth" v-if="isColumnVisible('deal.address')">
                            <el-input v-model="filterModel.address" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.expense_type" :label-width="formLabelWidth" v-if="isColumnVisible('expense_type')">
                            <el-select
                                v-model="filterModel.expense_type"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.expense_type"
                                size="mini"
                            >
                                <el-option v-for="item in expenseTypeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.recipient_type" :label-width="formLabelWidth" v-if="isColumnVisible('recipient_type')">
                            <el-select
                                v-model="filterModel.recipient_type"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                :placeholder="fieldsNames.recipient_type"
                                size="mini"
                            >
                                <el-option v-for="item in receivedFromTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.recipient_id" :label-width="formLabelWidth" v-if="isColumnVisible('recipient_id')">
                            <el-select
                                v-model="filterModel.recipient_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                collapse-tags
                                clearable
                                autocomplete
                                multiple
                                :placeholder="fieldsNames.recipient_id"
                                size="mini"
                            >
                                <el-option v-for="item in receivedByIdListForFilter" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.office_id" :label-width="formLabelWidth" v-if="isColumnVisible('office_id')">
                            <el-select
                                v-model="filterModel.office_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                autocomplete
                                :placeholder="fieldsNames.office_id"
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.period" :label-width="formLabelWidth" v-if="false">
                            <el-date-picker
                                v-model="filterModel.period"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.amount" :label-width="formLabelWidth" v-if="isColumnVisible('amount')">
                            <el-input v-model="filterModel.amount" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard" v-if="headerOptions.isNewButtonVisible && canCreateIncome">
                    новый приход
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import ExpenseMixin from '@/mixins/expense';
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';
import MassExpenseDealEditPopup from '@/components/expenses/MassExpenseDealEditPopup';

library.add(faEye);

export default {
    name: 'ExpenseBaseGrid',
    mixins: [
        ExpenseMixin
    ],
    data() {
        return {
            title: 'Расходы по сделке',
            pageName: 'expenses-deals',
            isExpenseVisible: false,
            expenseId: null,
            dealId: null,
            isFilterFormVisible: false,
            headerOptions: {
                isNewButtonVisible: false
            },
            settingName: 'expenses',
            isPayTypeFilterVisible: true,
            filterModel: {
                id: null,
                created_at: [],
                creator_full_name: [],
                deal_id: null,
                deal_contract: null,
                address: null,
                expense_type: [],
                recipient_type: '',
                recipient_id: [],
                office_id: null,
                //period: [],
                amount: null
            },
            fieldsNames: {
                id: 'id',
                created_at: 'дата создания',
                creator_full_name: 'создатель',
                deal_id: 'id сделки',
                deal_contract: 'договор №',
                address: 'адрес',
                expense_type: 'статья',
                recipient_type: 'получил тип',
                recipient_id: 'получил',
                office_id: 'офис',
                //period: 'отчётный период',
                amount: 'сумма'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            cashPayTypes: [],
            cashlessPayTypes: [],
            isCashLess: false
        };
    },
    components: {
        AgGridVue,
        MassExpenseDealEditPopup
    },
    computed: {
        expenses() {
            return this.$store.state.expenses.expenses;
        },
        pagesInfo() {
            return this.$store.state.expenses.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'creator_full_name':
                                result += this.getNames(this.employersList, field);
                                break;
                            case 'created_at':
                                result += `${this.fieldsNames[field]}: c ${this.filterModel[field][0]}
                                 по ${this.filterModel[field][1]}; `;
                                break;
                            case 'expense_type':
                                result += this.getNames(this.expenseTypeList, field);
                                break;
                            case 'recipient_type':
                                result += this.getOneName(this.receivedFromTypesList, field);
                                break;
                            case 'recipient_id':
                                result += this.getNames(this.receivedByIdListForFilter, field);
                                break;
                            case 'office_id':
                                result += this.getNames(this.officeList, field);
                                break;
                            default:
                                result += `${this.fieldsNames[field]}: ${this.filterModel[field]}; `;
                        }
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        }
    },
    created() {
        this.cashPayTypes = this.localReferences.payTypesCash;
        this.cashlessPayTypes = this.localReferences.payTypesCashless;
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.id),
                field: 'id'
            },
            {
                headerName: this.capitalize(this.fieldsNames.created_at),
                field: 'created_at'
            },
            {
                headerName: this.capitalize(this.fieldsNames.creator_full_name),
                field: 'created_by.full_name'
            },
            {
                headerName: `${this.capitalize(this.fieldsNames.deal_id)}`,
                field: 'deal_id',
                cellRenderer: ({ data }) => {
                    return this.getLinkElement(data.deal.id,
                        data.deal.id,
                        { name: 'deal-card', params: { id: data.deal.id } },
                        'a', 'spreadsheet-table-id-link');
                },
                hide: false
            },
            {
                headerName: this.capitalize(this.fieldsNames.deal_contract),
                field: 'deal.contract_number',
                cellRenderer: ({ data }) => {
                    if (data.deal && data.deal.contract_number && data.deal.contract_date) {
                        return `${data.deal.contract_number} от ${data.deal.contract_date}`;
                    }
                    return '';
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.address),
                field: 'deal.address'
            },
            {
                headerName: this.capitalize(this.fieldsNames.expense_type),
                field: 'expense_type',
                sortable: false,
                cellRenderer: ({ data }) => data.details ? this.getName(this.expenseTypeList, data.details.map(item => item.expense_type)) : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.recipient_type),
                field: 'recipient_type',
                cellRenderer: ({ data }) => this.getName(this.receivedFromTypesList, data.recipient_type)
            },
            {
                headerName: this.capitalize(this.fieldsNames.recipient_id),
                field: 'recipient_id',
                cellRenderer: ({ data }) => data.recipient.name
            },
            {
                headerName: this.capitalize(this.fieldsNames.office_id),
                field: 'office_id',
                cellRenderer: ({ data }) => data.deal.responsible_user.office_name
            },
            //{
            //headerName: this.capitalize(this.fieldsNames.period),
            //field: ''
            //},
            {
                headerName: this.capitalize(this.fieldsNames.amount),
                field: 'amount'
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: ({ data }) => {
                    return this.getLinkElement(data.id, '', this.getRouteForCard(data), 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.loadSettings();
        this.$store.commit('expenses/setCurrentPage', this.pageName);
    },
    methods: {
        loadSettings: function() {
            this.$store.dispatch('preferences/getPreferences').then(
                () => {
                    this.setSettings();
                }).catch(() => {
                this.getDataFromServer();
            });
        },
        setSettings() {
            const settings = this.setting[this.settingName];
            if (settings) {
                this.gridOptions.columnApi.setColumnState(settings.table);
                this.gridOptions.api.setSortModel({});
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
                this.pageModel = JSON.parse(JSON.stringify(settings.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
            }
            element.innerText = name;
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        edit() {
            this.$router.push({ name: 'expense-edit', params: { id: '' + this.id } });
        },
        getRouteForCard(data) {
            const params = { id: '' + data.id };
            return { name: 'expense-edit', params };
        },
        onSelectionChanged(e) {
            this.showExpense(e.node.data.id);
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel,
                pageName: this.pageName
            };
            this.loading = true;
            this.$store.dispatch('expenses/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.expenses);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                }).finally(() => {
                this.loading = false;
            });
        },
        async getExpense() {
            this.loadingMain = true;
            try {
                this.expense = await this.$store.dispatch('expenses/getExpense', this.id);
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        showExpense(expenseId) {
            this.isExpenseVisible = !this.isExpenseVisible;
            this.$emit('changeVisibility', this.isExpenseVisible);
            this.expenseId = expenseId;
        },
        changeVisibility() {
            this.$emit('changeVisibility', false);
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = null;
        },
        goNewCard() {
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {};
            data[this.settingName] = {
                'table': this.gridOptions.columnApi.getColumnState(),
                'sort': this.gridOptions.api.getSortModel(),
                'filter': this.filterModel,
                'page': this.pageModel
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize,
        getNames(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]}: ${this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ')}; `;
            }
            return '';
        },
        getOneName(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]}: ${obj.filter(item => item.id === this.filterModel[field]).map(item => item.name).join('')}; `;
            }
            return '';
        }
    }
};
</script>
